<template>
  <div class="resume-work-experience-wrap clearfix" v-if="work&&work.length">
    <div class="progress-content">
      <ul>
        <li class="clearfix" v-for="(exp,index) in work" :key="index">
          <em></em>
          <i></i>
          <div class="img-wrap">
            <img :src="exp.companyLogo | avatar('company')" v-img-error-company alt="" />
          </div>
          <div class="info-box">
            <p>{{exp.startTime}} - {{exp.endTime | formatMonthSelect}}（{{exp | timeRange}}）</p>
            <p v-if="exp.companyName" v-html="exp.companyName"></p>
            <p class="separate-info-list clearfix">
              <span v-if="exp.position" v-html="exp.position"></span>
              <span v-if="exp.department">{{exp.department}}</span>
            </p>
          </div>
          <ul class="inner-list-info clearfix">
            <li v-if="exp.industryIds && exp.industryIds.length">
              <span class="label">所属行业</span>
              <p>{{exp.industryIds | industry}}</p>
            </li>
            <li v-if="exp.companySize">
              <span class="label">公司规模</span>
              <p>{{exp.companySize}}</p>
            </li>
            <li v-if="exp.companyDescription">
              <span class="label">公司介绍</span>
              <p>{{exp.companyDescription}}</p>
            </li>
            <li v-if="exp.companyType">
              <span class="label">公司性质</span>
              <p>{{exp.companyType}}</p>
            </li>
            <li v-if="exp.responsibleArea || exp.overseasWork==1">
              <span class="label">负责区域</span>
              <p>{{exp.responsibleArea}}{{exp.overseasWork==1?'(海外)':''}}</p>
            </li>
            <li v-if="exp.leader">
              <span class="label">汇报对象</span>
              <p>{{exp.leader}}</p>
            </li>
            <li v-if="parseInt(exp.underlingNumber)">
              <span class="label">下属人数</span>
              <p>{{exp.underlingNumber}}人</p>
            </li>
            <li>
              <span class="label">工作职责</span>
              <p v-html="exp.description"></p>
            </li>
            <li v-if="exp.achievement">
              <span class="label">工作业绩</span>
              <p v-html="exp.achievement"></p>
            </li>
            <li v-if="exp.reasonOfLeaving">
              <span class="label">离职原因</span>
              <p v-html="exp.reasonOfLeaving"></p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .img-wrap{
    border-radius: 0;
  }
</style>
<script>
export default {
  props:{
    work: {}
  },
  data(){
    return{
    };
  },
  components: {
  },
  methods: {
  },
  created() {
  }
};
</script>
